
// import React from 'react';
// import { Link } from 'react-router-dom';
// import {
//   FiArrowRight,
//   FiZap,
//   FiTool,
//   FiTruck,
//   FiShield,
//   FiCheckCircle,
//   FiPhoneCall,
//   FiCheck,
//   FiGlobe,
//   FiTarget,
//   FiSettings,
//   FiHome,
//     FiCalendar,   // NEW
//   FiUsers, 
//   // NEW — for the marquee
//   FiTrendingUp,
//   FiActivity,
//   FiLink,
//   FiBox,
//   FiToggleLeft,
//   FiToggleRight,
//   FiAlertTriangle,
// } from 'react-icons/fi';

// import pACSR from '../assest/product image transparent/01_ACSR_Conductors.png.png';
// import pGIFabrication from '../assest/v crosss.jpg';
// import pControlPanel from '../assest/product image transparent/Control_Panels_and_Distribution_Panel.png.png';
// import pSteelPole from '../assest/NEW RA.png';
// import pLA from '../assest/product image transparent/11kV_Polymeric_Type_Lightning_Arrester.png.png';
// import pCable from '../assest/product image transparent/MV_XLPE_Insulated_Armoured_Cable.png.png'; // TODO: add a cables product image with this exact filename
// import pInsulator from '../assest/product image transparent/33kV_Polymer_Pin_Insulator_10kN_Strength.png.png'; // TODO: add an insulators product image with this exact filename
// import transformerImg from '../assest/transformer/transformer_1.jpg'; // TODO: add your transformer product image with this exact filename
// import testTransformerImg from '../assest/manufacturing/sections/test_transformer.png';
// import testPanelImg from '../assest/manufacturing/sections/test_panel.png';
// import testPoleImg from '../assest/manufacturing/sections/test_pole.png';

// import imgVision from '../assest/company/vision.jpg';
// import imgServices from '../assest/company/services.jpg';
// import imgFacilities from '../assest/company/facilities.jpg';

// import logoLT from '../assest/company logo/Larsen & Toubro.jpg';
// import logoShapoorji from '../assest/company logo/Shapoorji Pallonji.jpg';
// import logoIndianOil from '../assest/company logo/Indian Oil.jpg';
// import logoJaguar from '../assest/company logo/Jaguar Overseas.jpg';
// import logoRamky from '../assest/company logo/Ramky Infra Ltd.jpg';
// import logoDrake from '../assest/company logo/Drake & Skull.jpg';

// import Reveal from '../common/Reveal';
// import Counter from '../common/Counter';
// import HeroSlider from '../common/HeroSlider';
// import CategoryReel from '../common/CategoryReel';
// import { slugify } from '../data/categories'; // NEW — used to link "View Details" buttons straight to the right product category

// const clientLogos = [
//   { name: 'L&T Construction', logo: logoLT },
//   { name: 'Shapoorji Pallonji', logo: logoShapoorji },
//   { name: 'Indian Oil', logo: logoIndianOil },
//   { name: 'Jaguar Overseas', logo: logoJaguar },
//   { name: 'Ramky Infra Ltd.', logo: logoRamky },
//   { name: 'Drake & Skull', logo: logoDrake },
// ];

// const productList = [
//   { name: 'Transformers', Icon: FiZap },
//   { name: 'All Types of Electric Poles', Icon: FiTrendingUp },
//   { name: 'Concrete Poles', Icon: FiBox },
//   { name: 'ACSR Conductors', Icon: FiActivity },
//   { name: 'Insulated Armoured Cables', Icon: FiLink },
//   { name: 'Cable Boxes', Icon: FiBox },
//   { name: 'Pin Insulators', Icon: FiShield },
//   { name: 'Disc Insulators', Icon: FiShield },
//   { name: 'Drop Out Fuses', Icon: FiAlertTriangle },
//   { name: 'Air Break Switches', Icon: FiToggleLeft },
//   { name: 'Isolators', Icon: FiToggleRight },
//   { name: 'Lightning Arresters', Icon: FiZap },
//   { name: 'Control Panels', Icon: FiSettings },
// ];
// // Detailed "What we do, end to end" services — moved over from About page
// const services = [
//   {
//     icon: FiTool,
//     title: 'Transformer Manufacturing',
//     tag: 'Core Manufacturing',
//     desc: 'We manufacture Distribution Transformers (DTR) entirely in-house, from raw core & winding stage to final testing — giving us complete control over quality at every step.',
//     points: [
//       'Capacity range from 25 kVA up to 20000 kVA',
//       'Oil-cooled design built to relevant BIS standards',
//       'Every unit tested for insulation, efficiency & load before dispatch',
//     ],
//     img: transformerImg,
//   },
//   {
//     icon: FiZap,
//     title: 'All Types of Electric Poles',
//     tag: 'Core Manufacturing',
//     desc: 'Our in-house fabrication unit produces the full range of electric poles used across HT/LT power distribution lines — built to exact client and utility specifications.',
//     points: [
//       'PSC Pole',
//       'Rail Pole',
//       'Tubular Pole',
//       'Octagonal Pole',
//       'RSJ Pole',
//     ],
//     img: pSteelPole,
//   },
//   {
//     icon: FiShield,
//     title: 'Control & Distribution Panels',
//     tag: 'Core Manufacturing',
//     desc: 'We design and manufacture control panels and distribution boards used across substations, industrial units and utility installations.',
//     points: [
//       'Built with quality-checked electrical components',
//       'Tested for safety, load handling & performance',
//       'Custom configurations available as per project need',
//     ],
//     img: pControlPanel,
//   },

//   {
//     icon: FiTruck,
//     title: 'Trading & Supply',
//     tag: 'Trading Basis',
//     desc: 'Beyond manufacturing, we also source and supply a wider range of electrical goods & components across the full 33 kV range on a trading basis — so clients get everything under one roof.',
//     tradingItems: [
//       { name: 'ACSR Conductors', img: pACSR },
//       { name: 'Lightning Arresters', img: pLA },
//       { name: 'Cables', img: pCable },
//       { name: 'Insulators', img: pInsulator },
//     ],
//   },
// ];


// // Quality Testing groups — copied from the Manufacturing page
// const testingGroups = [
//   {
//     icon: FiZap,
//     title: 'Transformer Testing',
//     img: testTransformerImg,
//     points: [
//       'Ratio Test (TTR)',
//       'Winding Resistance Test',
//       'No Load & Load Loss Test',
//       'Dielectric Withstand Test',
//       'Oil Breakdown Voltage Test',
//       'Temperature Rise Test',
//     ],
//   },
//   {
//     icon: FiSettings,
//     title: 'Control Panel Testing',
//     img: testPanelImg,
//     points: [
//       'Insulation Resistance Test',
//       'Dielectric Withstand Test',
//       'Functional Operation Test',
//       'Protection Relay Test',
//       'Wiring & Continuity Check',
//       'Busbar & Component Check',
//     ],
//   },
//   {
//     icon: FiTool,
//     title: 'Pole Testing',
//     img: testPoleImg,
//     points: [
//       'Dimensional Inspection',
//       'Galvanization Thickness Test',
//       'Weld Quality Inspection',
//       'Load / Deflection Test',
//       'Verticality & Strength Test',
//       'Surface Finish Inspection',
//     ],
//   },
// ];

// // Custom line-art icons matching the reference style
// const IconCalendar = ({ color }) => (
//   <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
//     <rect x="3" y="5" width="18" height="16" rx="2" stroke={color} strokeWidth="1.6" />
//     <path d="M3 9.5H21" stroke={color} strokeWidth="1.6" />
//     <path d="M7 3V6.5" stroke={color} strokeWidth="1.6" strokeLinecap="round" />
//     <path d="M17 3V6.5" stroke={color} strokeWidth="1.6" strokeLinecap="round" />
//     <path d="M7.5 13H9.5M11.5 13H13.5M15.5 13H17M7.5 16.5H9.5M11.5 16.5H13.5M15.5 16.5H17"
//       stroke={color} strokeWidth="1.4" strokeLinecap="round" />
//   </svg>
// );

// const IconLightning = ({ color }) => (
//   <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
//     <path d="M13 2 L4 14h6l-1 8 9-12h-6l1-8z" stroke={color} strokeWidth="1.6" strokeLinejoin="round" />
//   </svg>
// );

// const IconWrench = ({ color }) => (
//   <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
//     <path
//       d="M14.7 6.3a4 4 0 0 0-5.4 5.4L3 18l3 3 6.3-6.3a4 4 0 0 0 5.4-5.4l-2.83 2.83-2.12-2.12L14.7 6.3z"
//       stroke={color}
//       strokeWidth="1.6"
//       strokeLinejoin="round"
//       strokeLinecap="round"
//     />
//   </svg>
// );

// const IconUsers = ({ color }) => (
//   <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
//     <circle cx="9" cy="8" r="3" stroke={color} strokeWidth="1.6" />
//     <path d="M3.5 20c0-3 2.5-5.5 5.5-5.5S14.5 17 14.5 20" stroke={color} strokeWidth="1.6" strokeLinecap="round" />
//     <circle cx="17" cy="9" r="2.4" stroke={color} strokeWidth="1.6" />
//     <path d="M15.8 14.6c2.6.2 4.7 2.3 4.7 5" stroke={color} strokeWidth="1.6" strokeLinecap="round" />
//   </svg>
// );

// // Rotating gradient ring wrapper — exact style from reference
// const GradientRingIcon = ({ Icon, colorFrom, colorTo, id }) => (
//   <div className="relative flex h-20 w-20 items-center justify-center">
//     <svg viewBox="0 0 100 100" className="absolute inset-0 h-full w-full">
//       <defs>
//         <linearGradient id={`grad-${id}`} x1="0%" y1="0%" x2="100%" y2="100%">
//           <stop offset="0%" stopColor={colorFrom} />
//           <stop offset="100%" stopColor={colorTo} />
//         </linearGradient>
//       </defs>
//       <path d="M 25 20 A 35 35 0 0 1 78 40" fill="none" stroke={`url(#grad-${id})`} strokeWidth="3.5" strokeLinecap="round" />
//       <path d="M 70 32 L 78 40 L 68 44" fill="none" stroke={colorFrom} strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
//       <path d="M 75 80 A 35 35 0 0 1 22 60" fill="none" stroke={`url(#grad-${id})`} strokeWidth="3.5" strokeLinecap="round" />
//       <path d="M 30 68 L 22 60 L 32 56" fill="none" stroke={colorTo} strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
//     </svg>
//     <Icon color={colorTo} />
//   </div>
// );



// const whyUs = [
//   {
//     icon: FiShield,
//     title: 'Govt. Approved Manufacturer',
//     desc: 'Registered manufacturer & trader for electrical power distribution equipment.',
//   },
//   {
//     icon: FiCalendar,
//     title: '17+ Years Experience',
//     desc: 'Hands-on expertise across the power distribution sector since inception.',
//   },
//   {
//     icon: FiGlobe,
//     title: 'Multi-State Delivery',
//     desc: 'Projects executed and delivered across multiple states in India.',
//   },
//   {
//     icon: FiTool,
//     title: 'In-House Manufacturing',
//     desc: 'DTRs, poles & panels made on our own floor — quality stays in our hands.',
//   },
//   {
//     icon: FiUsers,
//     title: 'Trusted by Major Clients',
//     desc: 'Worked with L&T, Shapoorji Pallonji, Indian Oil and other leading names.',
//   },
//   {
//     icon: FiCheckCircle,
//     title: 'Zero Defect Policy',
//     desc: 'Every product tested and verified against BIS & IEC standards before dispatch.',
//   },
// ];

// // Quality Policy checklist — same content as reference
// const qualityPolicy = [
//   {
//     title: 'ISO 9001:2015 Certified',
//     desc: 'Quality management system certification',
//   },
//   {
//     title: 'IEC / BIS Aligned',
//     desc: 'Design & type-testing per Indian and international standards',
//   },
//   {
//     title: 'NABL Tested',
//     desc: 'Calibration lab verified — accuracy on every component',
//   },
//   {
//     title: 'Government Approved',
//     desc: 'Registered contractor for public distribution projects',
//   },
// ];

// // Company Information cards — content pulled from the Prithviraj catalogue
// const companyInfo = [
//   {
//     icon: FiGlobe,
//     title: 'About Prithviraj',
//    desc: 'A government-approved manufacturer & trader of electrical power distribution equipment, with our registered workshop at Barauni, Begusarai, Bihar, and a corporate office in Gurugram, Haryana. Since 2018, we\'ve built our reputation on responsiveness, delivery commitments, and unparalleled quality.',
//     img: null, // TODO: client image pending — add to src/assest/company/about.jpg and set here
//   },
//   {
//     icon: FiTarget,
//     title: 'Goal & Vision',
//     desc: 'To achieve consistency in delivering high-quality, value-added manufacturing & trading services through absolute professionalism and timely execution — and to be recognized as a key player in the power distribution sector.',
//     img: imgVision,
//   },
//   {
//     icon: FiSettings,
//     title: 'Our Services',
//     desc: 'In-house manufacturing of DTRs from 25 kVA to 20000 kVA, steel structure fabrication, and trading of electrical goods across the full 33 kV voltage range.',
//     img: imgServices,
//   },
//   {
//     icon: FiHome,
//     title: 'Our Facilities',
//     desc: 'A dedicated manufacturing workshop at Barauni, Begusarai, Bihar for transformers and steel fabrication, backed by a corporate office at Aspaze I Tech Park, Sohna Road, Gurugram.',
//     img: imgFacilities,
//   },
// ];

// // ---------------------------------------------------------------------------
// // "OUR RANGE" spotlight cards — each now carries the EXACT category title
// // (as used in src/data/categories.js) so the "View Details" button can jump
// // straight to that category's section on the Products page, instead of just
// // opening the Products page at the top.
// // ---------------------------------------------------------------------------
// const rangeItems = [
//   { name: 'Transformers', desc: 'In-house DTR manufacturing, 25 kVA – 20000 kVA.', img: transformerImg, category: 'Transformers' },
//   { name: 'All Types of Electric Poles', desc: 'PSC, Rail, Tubular, Octagonal & RSJ poles for HT/LT lines.', img: pSteelPole, category: 'Tower & Pole Support' },
//   { name: 'Control & Distribution Panels', desc: 'Quality-checked panels for power distribution.', img: pControlPanel, category: 'Control Panel' },
//   { name: 'All Types of Electrical GI Fabrication', desc: 'Custom GI fabrication for transmission & distribution structures.', img: pGIFabrication, category: 'Electrical GI Fabrication' },
//   { name: 'ACSR Conductors', desc: 'Reliable conductors across the 33 kV range.', img: pACSR, category: 'Electrical Conductors' },
//   { name: 'Lightning Arresters', desc: '11kV polymeric type arresters.', img: pLA, category: 'Lightning Arrestor' },
//   { name: 'Cables', desc: 'MV XLPE insulated armoured cables.', img: pCable, category: 'Insulated Armoured Cables' },
//   { name: 'Insulators', desc: '33kV polymer pin insulators, 10kN strength.', img: pInsulator, category: 'Pin Insulators' },
// ];

// export default function Home() {
//   return (
//     <div className="overflow-x-hidden ">
//       {/* ---------------- HERO SLIDER ---------------- */}
//       <HeroSlider />

//       {/* ---------------- PRODUCT NAME MARQUEE (below hero) ---------------- */}
//      {/* ---------------- PRODUCT NAME MARQUEE (below hero) ---------------- */}
// <section className="w-full overflow-hidden  bg-navy py-4">
//   <div className="overflow-hidden">
//     <div className="marquee-track flex items-center gap-12 pl-10">
//       {[...productList, ...productList].map((p, i) => {
//         const Icon = p.Icon;
//         return (
//           <span key={p.name + i} className="flex items-center gap-3 whitespace-nowrap">
//             <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white text-brand-orange shadow-sm">
//               <Icon size={16} strokeWidth={2.5} />
//             </span>
//             <span className="text-lg font-extrabold uppercase tracking-wide text-white transition-all duration-200 hover:scale-110 sm:text-2xl">
//               {p.name}
//             </span>
//           </span>
//         );
//       })}
//     </div>
//   </div>
// </section>

//       {/* ---------------- STATS ---------------- */}
//     {/* ---------------- STATS ---------------- */}


// {/* ---------------- STATS ---------------- */}
// <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
//   <div className="rounded-3xl bg-navy px-6 py-10 sm:px-10 sm:py-16">
//     <Reveal className="mb-10 text-center sm:mb-12">
//       {/* Main Heading */}
//       <h2 className="text-3xl font-extrabold uppercase leading-tight sm:text-5xl lg:text-6xl">
//         <span className="hero-shimmer block text-brand-orange">
//           BY THE NUMBERS
//         </span>
//       </h2>

//       {/* Secondary Heading */}
//       <h3 className="mt-3 text-xl font-bold text-white sm:mt-4 sm:text-3xl lg:text-4xl">
//         Our Key Numbers
//       </h3>
//     </Reveal>

//     <div className="grid grid-cols-2 gap-x-4 gap-y-10 sm:grid-cols-4 sm:gap-x-6 sm:gap-y-12">
//       {[
//         { Icon: IconCalendar, value: 17, suffix: '+', label: 'Years in the sector' },
//         { Icon: IconLightning, value: 33, suffix: ' kV', label: 'Voltage range served' },
//         { Icon: IconWrench, value: 20000, suffix: ' kVA', label: 'TRANSFORMER CAPACITY' },
//         { Icon: IconUsers, value: 7, suffix: '+', label: 'Major clients served' },
//       ].map((s, i) => (
//         <Reveal key={s.label} delay={i * 100}>
//           <div className="flex flex-col items-center text-center transition-transform duration-300 hover:-translate-y-1">
//             <GradientRingIcon Icon={s.Icon} colorFrom="#34d399" colorTo="#38bdf8" id={`stat-${i}`} />
//             <p className="mt-4 text-3xl font-extrabold text-white sm:mt-5 sm:text-5xl">
//               <Counter value={s.value} suffix={s.suffix} />
//             </p>
//             <span className="mt-3 block h-1 w-12 rounded-full bg-gradient-to-r from-emerald-400 to-sky-400" />
//             <p className="mt-3 max-w-[9rem] text-[11px] font-semibold uppercase leading-snug tracking-wide text-white/60 sm:max-w-none sm:text-sm">
//               {s.label}
//             </p>
//           </div>
//         </Reveal>
//       ))}
//     </div>
//   </div>
// </section>

//       {/* ---------------- PRODUCT SPOTLIGHT (one product per section, animated) ---------------- */}
//       {/* <ProductSpotlight /> */}
//    <section className="relative py-16 sm:py-20  overflow-hidden">
//   <div className="pointer-events-none absolute -top-24 left-1/2 h-72 w-72 -translate-x-1/2 rounded-full bg-brand-orange/10 blur-3xl" />

//   <style>{`
//     .pcard {
//       position: relative;
//       width: 256px;
//       border-radius: 20px;
//       padding: 3px;
//       background: linear-gradient(163deg, #abd373 0%, #ff9f0d 100%);
//       transition: box-shadow .35s ease, transform .35s ease;
//       cursor: pointer;
//     }
//     .pcard:hover {
//       box-shadow: 0 0 25px 2px rgba(171, 211, 115, 0.55),
//                   0 0 45px 6px rgba(255, 159, 13, 0.25);
//       transform: translateY(-6px);
//     }
//     .pcard-inner {
//       width: 100%;
//       height: 100%;
//       border-radius: 18px;
//       background-color: #101a2c;
//       padding: 24px 20px;
//       display: flex;
//       flex-direction: column;
//       align-items: center;
//       gap: 8px;
//       transition: transform .25s ease, background-color .25s ease;
//     }
//     .pcard:hover .pcard-inner {
//       transform: scale(0.96);
//     }
//     .pcard-inner img {
//       transition: transform .35s ease;
//     }
//     .pcard:hover .pcard-inner .pcard-img {
//       transform: translateY(-6px);
//     }
//     /* description grows to fill leftover space so the button always lands at the same spot */
//     .pcard-desc {
//       flex: 1 1 auto;
//       display: flex;
//       align-items: flex-start;
//       justify-content: center;
//     }
//     /* button pinned to bottom of the card, regardless of description length */
//     .pcard-btn {
//       margin-top: auto;
//     }
//   `}</style>

//   <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
//     <Reveal className="mx-auto max-w-3xl text-center">
//       {/* Main Heading */}
//       <h2 className="text-4xl font-extrabold uppercase leading-none sm:text-5xl lg:text-6xl">
//         <span className="hero-shimmer block text-brand-orange">
//           OUR RANGE
//         </span>
//       </h2>

//       {/* Secondary Heading */}
//       <h3 className="mt-4 text-2xl font-bold text-navy sm:text-3xl lg:text-4xl">
//         Explore Our{" "}
//         Product Range
//       </h3>

//       {/* Description */}
//       <p className="mx-auto mt-5 max-w-2xl text-base leading-7 text-slate-600  sm:text-lg">
//         From in-house manufactured transformers to a full range of traded
//         electrical components.
//       </p>
//     </Reveal>

//     <div className="mt-12 flex flex-wrap items-stretch justify-center gap-6">
//       {rangeItems.map((p) => (
//         <div key={p.name} className="pcard">
//           <div className="pcard-inner">
//             <div className="pcard-img w-28 aspect-square rounded-full p-2 bg-white overflow-hidden shadow-md mx-auto">
//               <img src={p.img} alt={p.name} className="h-full w-full object-contain" />
//             </div>

//             <p className="font-semibold text-white tracking-wide text-lg text-center">
//               {p.name}
//             </p>

//             {/* grows to fill leftover space so button aligns across cards */}
//             <p className="pcard-desc font-medium text-white/60 text-xs text-center">
//               {p.desc}
//             </p>

//             {/* CHANGED: now jumps straight to this product's category section
//                 on the Products page (e.g. /products#transformers) instead of
//                 just opening /products at the top. */}
//             <Link
//               to={`/products#${slugify(p.category)}`}
//               className="pcard-btn inline-flex items-center gap-2 py-2 px-5 text-sm font-semibold rounded-full
//                 bg-brand-orange text-white shadow-[0_0_20px_rgba(255,159,13,0.4)]"
//             >
//               View Details
//             </Link>
//           </div>
//         </div>
//       ))}
//     </div>
//   </div>
// </section>

//       {/* ---------------- PRODUCT CATEGORY REEL (big centered title + sliding images) ---------------- */}
//       <CategoryReel />

//       {/* ---------------- SERVICES: "What we do, end to end" (detailed rows: text + image) ---------------- */}
// <section className="py-16 sm:py-20 overflow-hidden">
//   <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
//     <Reveal className="mx-auto max-w-3xl text-center">
//       {/* Main Heading */}
//       <h2 className="break-words text-4xl font-extrabold uppercase leading-none sm:text-5xl lg:text-6xl">
//         <span className="hero-shimmer block text-brand-orange">
//           AT A GLANCE
//         </span>
//       </h2>

//       {/* Secondary Heading */}
//       <h3 className="mt-4 break-words text-xl font-bold leading-tight text-navy sm:text-2xl lg:text-3xl">
//         What We Do, End to End
//       </h3>

//       {/* Description */}
//       <p className="mx-auto mt-5 max-w-2xl text-base leading-7 text-slate-600 sm:text-lg">
//         Manufacturing kept in-house, quality kept in our hands — supported by
//         trading & supply for everything else our clients need.
//       </p>
//     </Reveal>

//     <div className="mt-14 grid gap-6 sm:grid-cols-2">
//       {services.map((s, i) => {
//         const Icon = s.icon;
//         const isTrading = s.tag === 'Trading Basis';
//         return (
//           <Reveal key={s.title} delay={i * 80}>
//             {/* ---- outer wrapper: subtle static gradient border (no spin) ---- */}
//             <div className="group relative h-full overflow-hidden rounded-3xl p-[1.5px] bg-gradient-to-br from-brand-orange/25 via-white/5 to-transparent">
//               {/* ---- actual card: flat solid dark navy background ---- */}
//               <div
//                 className="relative z-10 flex h-full flex-col rounded-3xl bg-[#0B0F1F] p-6 shadow-[inset_0_-16px_24px_0_rgba(255,255,255,0.03)] transition-transform duration-300 ease-out sm:p-7"
//               >
//                 {/* Icon + Tag */}
//                 <div className="flex items-center gap-3">
//                   <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white/10 text-brand-orange">
//                     <Icon size={20} />
//                   </span>
//                   <span className="inline-flex items-center rounded-full bg-white/10 px-3 py-1 text-[11px] font-bold uppercase tracking-wide text-brand-orange">
//                     {s.tag}
//                   </span>
//                 </div>

//                 {/* Title */}
//                 <h2 className="mt-4 text-xl font-extrabold text-white sm:text-2xl">
//                   {s.title}
//                 </h2>

//                 {/* Description */}
//                 <p className="mt-2 text-sm leading-relaxed text-white/70">
//                   {s.desc}
//                 </p>

//                 <span className="mt-4 block h-[1px] w-full bg-white/10" />

//                 {/* Content row: points + image tile(s) */}
//                 <div className="mt-4 flex flex-1 items-start gap-5">
//                   {s.points && (
//                     <ul className="flex-1 space-y-2.5">
//                       {s.points.map((pt) => (
//                         <li key={pt} className="flex items-start gap-2">
//                           <FiCheckCircle className="mt-0.5 shrink-0 text-brand-orange" size={15} />
//                           <span className="text-xs leading-relaxed text-white/80 sm:text-sm">{pt}</span>
//                         </li>
//                       ))}
//                     </ul>
//                   )}

//                   {isTrading ? (
//                     <div className="grid shrink-0 grid-cols-2 gap-2.5">
//                       {s.tradingItems.map((item) => (
//                         <div
//                           key={item.name}
//                           className="flex h-16 w-16 items-center justify-center overflow-hidden rounded-full bg-white p-2.5 shadow-md ring-1 ring-white/20 transition-transform duration-300 ease-out group-hover:scale-105 sm:h-20 sm:w-20"
//                           title={item.name}
//                         >
//                           <img
//                             src={item.img}
//                             alt={item.name}
//                             className="h-full w-full object-contain"
//                             loading="lazy"
//                           />
//                         </div>
//                       ))}
//                     </div>
//                   ) : (
//                     <div className="flex h-28 w-28 shrink-0 items-center justify-center overflow-hidden rounded-full bg-white p-4 shadow-md ring-1 ring-white/20 transition-transform duration-300 ease-out group-hover:scale-105 sm:h-32 sm:w-32">
//                       <img
//                         src={s.img}
//                         alt={s.title}
//                         className="h-full w-full object-contain"
//                         loading="lazy"
//                       />
//                     </div>
//                   )}
//                 </div>

//                 {/* Button — same gradient pill style as contact form submit */}
//                 <Link
//                   to="/products"
//                   className="group/btn mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-gradient-to-t from-brand-orangedark to-brand-orange px-6 py-3 text-sm font-bold uppercase tracking-wide text-white shadow-[inset_0_-2px_25px_-4px_rgba(255,255,255,0.4)] transition hover:-translate-y-0.5"
//                 >
//                   View Details
//                   <FiArrowRight className="transition group-hover/btn:translate-x-1" size={15} />
//                 </Link>
//               </div>
//             </div>
//           </Reveal>
//         );
//       })}
//     </div>
//   </div>
// </section>


//       {/* ---------------- QUALITY TESTING (copied from Manufacturing page) ---------------- */}
//    <section className="relative py-16 sm:py-20 overflow-hidden">
//   <div className="pointer-events-none absolute -top-24 left-1/2 h-72 w-72 -translate-x-1/2 rounded-full bg-brand-orange/10 blur-3xl" />

//   <style>{`
//     .tcard {
//       position: relative;
//       border-radius: 24px;
//       padding: 2px;
//       background: linear-gradient(163deg, #abd373 0%, #ff9f0d 100%);
//       transition: box-shadow .35s ease, transform .35s ease;
//     }
//     .tcard:hover {
//       box-shadow: 0 0 14px 1px rgba(171, 211, 115, 0.3),
//                   0 0 24px 3px rgba(255, 159, 13, 0.15);
//       transform: translateY(-3px);
//     }
//     .tcard-inner {
//       width: 100%;
//       height: 100%;
//       border-radius: 22px;
//       background-color: #101a2c;
//       transition: transform .25s ease;
//       overflow: hidden;
//     }
//     .tcard:hover .tcard-inner {
//       transform: scale(0.995);
//     }
//   `}</style>

//   <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
//     <Reveal className="mx-auto max-w-3xl text-center">
//       <h2 className="text-4xl font-extrabold uppercase leading-none sm:text-5xl lg:text-6xl">
//         <span className="hero-shimmer block text-brand-orange">
//           QUALITY TESTING
//         </span>
//       </h2>

//       <h3 className="mt-4 text-2xl font-bold text-navy sm:text-3xl lg:text-4xl">
//         Every Product, Tested Before It Ships
//       </h3>

//       <p className="mx-auto mt-5 max-w-2xl text-base leading-7 text-slate-600 sm:text-lg ">
//         Dedicated test setups for transformers, panels and poles — so nothing
//         leaves our floor without being verified against specification.
//       </p>
//     </Reveal>

//     <div className="mt-12 space-y-10">
//       {testingGroups.map((group, i) => {
//         const Icon = group.icon;
//         const imgFirst = i % 2 === 1;
//         return (
//           <div key={group.title} className="tcard">
//             <div className="tcard-inner grid items-stretch gap-8 p-6 sm:p-8 lg:grid-cols-2 lg:gap-12">
//               <Reveal direction="right" className={imgFirst ? 'order-2 lg:order-1' : ''}>
//                 {imgFirst ? (
//                   <div className="h-56 w-full overflow-hidden rounded-2xl sm:h-64 lg:h-full">
//                     <img src={group.img} alt={group.title} className="h-full w-full object-cover" loading="lazy" />
//                   </div>
//                 ) : (
//                   <div className="flex h-full flex-col justify-center">
//                     <div className="flex items-center gap-3">
//                       <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-white/10 text-brand-orange">
//                         <Icon size={20} />
//                       </span>
//                       <h3 className="text-lg font-extrabold text-white sm:text-xl">{group.title}</h3>
//                     </div>
//                     <ul className="mt-5 grid grid-cols-1 gap-2.5 sm:grid-cols-2">
//                       {group.points.map((p) => (
//                         <li key={p} className="flex items-start gap-2 text-sm text-white/90">
//                           <FiCheckCircle className="mt-0.5 shrink-0 text-brand-orange" size={16} />
//                           <span>{p}</span>
//                         </li>
//                       ))}
//                     </ul>
//                   </div>
//                 )}
//               </Reveal>
//               <Reveal direction="left" delay={120} className={imgFirst ? 'order-1 lg:order-2' : ''}>
//                 {imgFirst ? (
//                   <div className="flex h-full flex-col justify-center">
//                     <div className="flex items-center gap-3">
//                       <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-white/10 text-brand-orange">
//                         <Icon size={20} />
//                       </span>
//                       <h3 className="text-lg font-extrabold text-white sm:text-xl">{group.title}</h3>
//                     </div>
//                     <ul className="mt-5 grid grid-cols-1 gap-2.5 sm:grid-cols-2">
//                       {group.points.map((p) => (
//                         <li key={p} className="flex items-start gap-2 text-sm text-white/90">
//                           <FiCheckCircle className="mt-0.5 shrink-0 text-brand-orange" size={16} />
//                           <span>{p}</span>
//                         </li>
//                       ))}
//                     </ul>
//                   </div>
//                 ) : (
// <div className="h-56 w-full overflow-hidden rounded-2xl sm:h-64 lg:h-full">
//   <img
//     src={group.img}
//     alt={group.title}
//     className="h-full w-full scale-110 object-cover object-right"
//     loading="lazy"
//   />
// </div>
//                 )}
//               </Reveal>
//             </div>
//           </div>
//         );
//       })}
//     </div>
//   </div>
// </section>

//       {/* ---------------- EXPLORE OUR PRODUCT RANGE (Uiverse-style sliding color-reveal cards) ---------------- */}
    

//       {/* ---------------- COMPANY INFORMATION ---------------- */}
//    <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
//   <Reveal className="mx-auto max-w-3xl text-center">
//     {/* Main Heading */}
//     <h2 className="text-4xl font-extrabold uppercase leading-none sm:text-5xl lg:text-6xl">
//       <span className="hero-shimmer block text-brand-orange">
//         COMPANY INFORMATION
//       </span>
//     </h2>

//     {/* Secondary Heading */}
//     <h3 className="mt-4 text-2xl font-bold text-navy sm:text-3xl lg:text-4xl">
//       Who We Are & What We Stand For
//     </h3>
//   </Reveal>

//   <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
//     {companyInfo.map((c, i) => {
//       const Icon = c.icon;
//       return (
//         <Reveal key={c.title} delay={i * 100}>
//           <div className="group relative h-80 overflow-hidden rounded-2xl shadow-md transition duration-300 hover:-translate-y-1.5 hover:shadow-xl">
//             {/* fallback flat navy background jab tak client image na de */}
//             {!c.img && <div className="absolute inset-0 bg-navy" />}

//             {/* image ko halka zoom karo hover pe, thoda brighten bhi */}
//             {c.img && (
//               <div
//                 className="absolute inset-0 scale-100 bg-cover bg-center brightness-110 transition-transform duration-500 group-hover:scale-110"
//                 style={{ backgroundImage: `url(${c.img})` }}
//               />
//             )}

//             {/* dark gradient overlay taaki text readable rahe, thoda halka */}
//             <div className="absolute inset-0 bg-gradient-to-t from-navy/90 via-navy/50 to-navy/10" />

//             <div className="relative z-10 flex h-full flex-col justify-between p-7">
//               <span className="flex h-14 w-14 items-center justify-center rounded-full bg-white/10 text-white backdrop-blur-sm transition duration-300 group-hover:bg-brand-orange">
//                 <Icon size={24} />
//               </span>
//               <div>
//                 <h3 className="text-lg font-bold text-white">{c.title}</h3>
//                 <p className="mt-3 text-sm leading-relaxed text-white">{c.desc}</p>
//               </div>
//             </div>
//           </div>
//         </Reveal>
//       );
//     })}
//   </div>
// </section>

//       {/* ---------------- WHY CHOOSE US ---------------- */}
//    {/* ---------------- WHY CHOOSE US ---------------- */}
// {/* ---------------- WHY CHOOSE US ---------------- */}
// <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
//   <div className="grid items-center gap-12 lg:grid-cols-2">
//     {/* IMAGE SIDE */}
//     <Reveal direction="right">
//   <div className="relative overflow-hidden rounded-3xl shadow-xl">
//     <img
//       src={imgFacilities}
//       alt="Prithviraj Corporation workshop"
//       className="h-[420px] w-full object-cover sm:h-[480px]"
//     />
//   </div>
// </Reveal>

//     {/* TEXT + FEATURE GRID SIDE */}
//     <Reveal direction="left" delay={150}>
//       {/* Main Heading — same shimmer style as other sections */}
//       <h2 className="text-4xl font-extrabold uppercase leading-none sm:text-5xl lg:text-6xl">
//         <span className="hero-shimmer block text-brand-orange">
//           WHY PRITHVIRAJ
//         </span>
//       </h2>

//       {/* Secondary Heading */}
//       <h3 className="mt-4 text-2xl font-bold text-navy sm:text-3xl lg:text-4xl">
//         Built on Quality, Backed by Experience
//       </h3>

//       <p className="mt-4 text-slate-600">
//         From tendering to execution, we track every stage of a project —
//         planning, procurement and implementation — so our clients get
//         consistent, reliable delivery.
//       </p>

//       <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2">
//         {whyUs.map((item) => {
//           const Icon = item.icon;
//           return (
//             <div
//               key={item.title}
//               className="group flex items-start gap-4 rounded-xl border border-brand-orange/20 bg-white p-4 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-brand-orange hover:shadow-lg"
//             >
//               <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg border-2 border-brand-orange/30 bg-brand-orange/5 text-brand-orange transition-all duration-300 group-hover:border-brand-orange group-hover:bg-brand-orange group-hover:text-white">
//                 <Icon size={22} />
//               </span>
//               <div>
//                 <h4 className="text-sm font-bold text-navy">{item.title}</h4>
//                 <p className="mt-1 text-sm text-slate-500">{item.desc}</p>
//               </div>
//             </div>
//           );
//         })}
//       </div>

//       <Link
//         to="/about"
//         className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-brand-orange hover:text-brand-orangedark"
//       >
//         More about us <FiArrowRight />
//       </Link>
//     </Reveal>
//   </div>
// </section>

//       {/* ---------------- QUALITY POLICY ---------------- */}
//    <section className=" py-20">
//   <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
//     <div className="grid gap-12 lg:grid-cols-2">
//       <Reveal direction="right">
//         <span className="inline-flex items-center gap-2 rounded-full bg-brand-orange/10 px-4 py-1.5 font-mono text-sm font-bold uppercase tracking-[0.2em] text-brand-orange">
//           [06] Quality Policy
//         </span>
//         <h2 className="mt-4 text-3xl font-extrabold leading-[1.1] text-[#14110F] sm:text-4xl lg:text-5xl">
//           Zero defect. Not a<br />
//           slogan — a workshop<br />
//           discipline.
//         </h2>
//        <p className="mt-6 max-w-md text-slate-600">
//   Every product coming out of our facility is inspected against Bureau of Indian
//   Standards specs and IEC references. We follow a philosophy of continuous
//   improvement inspired by the Zero Defect / Zero Effect approach.
// </p>
//       </Reveal>

//       <Reveal direction="left" delay={150}>
//         <div className="divide-y divide-[#e3ded2] border-t border-[#e3ded2]">
//           {qualityPolicy.map((item) => (
//             <div
//               key={item.title}
//               className="group flex items-start justify-between gap-6 rounded-xl border border-[#e3ded2] bg-white p-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
//             >
//               <div>
//                 <h3 className="text-lg font-extrabold text-[#14110F] transition-colors duration-300 group-hover:text-brand-orange sm:text-xl">
//                   {item.title}
//                 </h3>
//                 <p className="mt-1 text-sm text-slate-500 sm:text-base">{item.desc}</p>
//               </div>
//               <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border-2 border-brand-orange text-brand-orange">
//                 <FiCheck size={16} strokeWidth={3} />
//               </div>
//             </div>
//           ))}
//         </div>
//       </Reveal>
//     </div>
//   </div>
// </section>

//       {/* ---------------- PRODUCT CATEGORY SHOWCASE ---------------- */}
    

//       <div className="mx-auto -mt-4 max-w-7xl px-4 pb-4 text-center sm:px-6 lg:px-8">
//         <Link
//           to="/products"
//           className="inline-flex items-center gap-2 text-sm font-semibold text-navy hover:text-brand-orange"
//         >
//           View full catalogue <FiArrowRight />
//         </Link>
//       </div>
//         {/* ---------------- TRUSTED BY MARQUEE ---------------- */}
//   <section className="border-y border-slate-100  py-6">
//   <style>{`
//     .logo-marquee-wrap {
//       overflow: hidden;
//     }
//     .logo-marquee-track {
//       display: flex;
//       width: max-content;
//       animation: logo-marquee-scroll 30s linear infinite;
//     }
//     /* Array ko 3 baar duplicate kiya hai, isliye exactly -33.3333% move karte hain.
//        Us point pe doosri copy bilkul wahi hoti hai jaha pehli copy shuru hui thi —
//        isliye loop restart hote waqt bilkul koi jump/pause/khaali gap nahi dikhta.
//        Agar isi naam ki koi aur CSS class kahin define hai to wo ise override kar
//        sakti hai — is unique naam (logo-marquee-track) se collision se bacha hai. */
//     @keyframes logo-marquee-scroll {
//       from { transform: translateX(0); }
//       to   { transform: translateX(-33.3333%); }
//     }
//     .logo-marquee-wrap:hover .logo-marquee-track {
//       animation-play-state: paused;
//     }
//   `}</style>

//   <p className="mb-4 text-center text-xs font-bold uppercase tracking-[0.3em] text-slate-600">
//     TRUSTED BY ORGANIZATIONS WE HAVE WORKED WITH
//   </p>
//   <div className="logo-marquee-wrap">
//     <div className="logo-marquee-track items-center gap-14 pl-10">
//       {[...clientLogos, ...clientLogos, ...clientLogos].map((c, i) => (
//         <span
//           key={c.name + i}
//           className="flex h-14 shrink-0 items-center justify-center whitespace-nowrap transition-transform duration-300 hover:scale-110"
//         >
//           <img
//             src={c.logo}
//             alt={c.name}
//             className="h-12 w-auto max-w-[160px] object-contain mix-blend-multiply sm:h-14"
//             onError={(e) => {
//               const target = e.currentTarget;
//               target.onerror = null;
//               target.style.display = 'none';
//               const fallback = document.createElement('span');
//               fallback.textContent = c.name;
//               fallback.className =
//                 'flex h-12 items-center justify-center px-3 text-sm font-bold text-slate-500 sm:h-14';
//               target.parentElement.appendChild(fallback);
//             }}
//           />
//         </span>
//       ))}
//     </div>
//   </div>
// </section>

//       {/* ---------------- CTA ---------------- */}
//       <section className="px-4 py-16 sm:px-6 lg:px-8">
//         <Reveal className="mx-auto max-w-5xl overflow-hidden rounded-3xl bg-navy px-8 py-12 text-center text-white sm:px-16">
//           <h2 className="text-2xl font-extrabold sm:text-3xl">
//             Need electrical manufacturing or trading services?
//           </h2>
//           <p className="mx-auto mt-3 max-w-xl text-white/70">
//             Tell us about your project and our team will get back to you with a plan and a quote.
//           </p>
//           <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
//             <Link
//               to="/contact"
//               className="inline-flex items-center gap-2 rounded-full bg-brand-orange px-6 py-3 text-sm font-semibold text-white transition hover:-translate-y-0.5 hover:bg-brand-orangedark"
//             >
//               <FiPhoneCall /> Talk to Us
//             </Link>
//             <a
//               href="tel:+91958260035"
//               className="inline-flex items-center gap-2 rounded-full border border-white/30 px-6 py-3 text-sm font-semibold text-white transition hover:-translate-y-0.5 hover:border-white"
//             >
//               +91 9958260035
//             </a>
//           </div>
//         </Reveal>
//       </section>
//     </div>
//   );
// }






import React from 'react';
import { Link } from 'react-router-dom';
import {
  FiArrowRight,
  FiZap,
  FiTool,
  FiTruck,
  FiShield,
  FiCheckCircle,
  FiPhoneCall,
  FiCheck,
  FiGlobe,
  FiTarget,
  FiSettings,
  FiHome,
    FiCalendar,   // NEW
  FiUsers, 
  // NEW — for the marquee
  FiTrendingUp,
  FiActivity,
  FiLink,
  FiBox,
  FiToggleLeft,
  FiToggleRight,
  FiAlertTriangle,
} from 'react-icons/fi';

import pACSR from '../assest/product image transparent/01_ACSR_Conductors.png.png';
import pGIFabrication from '../assest/v crosss.jpg';
import pControlPanel from '../assest/product image transparent/Control_Panels_and_Distribution_Panel.png.png';
import pSteelPole from '../assest/NEW RA.png';
import pLA from '../assest/product image transparent/11kV_Polymeric_Type_Lightning_Arrester.png.png';
import pCable from '../assest/product image transparent/MV_XLPE_Insulated_Armoured_Cable.png.png'; // TODO: add a cables product image with this exact filename
import pInsulator from '../assest/product image transparent/33kV_Polymer_Pin_Insulator_10kN_Strength.png.png'; // TODO: add an insulators product image with this exact filename
import transformerImg from '../assest/transformer/transformer_1.jpg'; // TODO: add your transformer product image with this exact filename
import testTransformerImg from '../assest/manufacturing/sections/test_transformer.png';
import testPanelImg from '../assest/manufacturing/sections/test_panel.png';
import testPoleImg from '../assest/manufacturing/sections/test_pole.png';

import imgVision from '../assest/company/vision.jpg';
import imgServices from '../assest/company/services.jpg';
import imgFacilities from '../assest/company/facilities.jpg';

import logoLT from '../assest/company logo/Larsen & Toubro.jpg';
import logoShapoorji from '../assest/company logo/Shapoorji Pallonji.jpg';
import logoIndianOil from '../assest/company logo/Indian Oil.jpg';
import logoJaguar from '../assest/company logo/Jaguar Overseas.jpg';
import logoRamky from '../assest/company logo/Ramky Infra Ltd.jpg';
import logoDrake from '../assest/company logo/Drake & Skull.jpg';

import Reveal from '../common/Reveal';
import Counter from '../common/Counter';
import HeroSlider from '../common/HeroSlider';
import CategoryReel from '../common/CategoryReel';
import { slugify } from '../data/categories'; // used to link "View Details" buttons straight to the right product category

const clientLogos = [
  { name: 'L&T Construction', logo: logoLT },
  { name: 'Shapoorji Pallonji', logo: logoShapoorji },
  { name: 'Indian Oil', logo: logoIndianOil },
  { name: 'Jaguar Overseas', logo: logoJaguar },
  { name: 'Ramky Infra Ltd.', logo: logoRamky },
  { name: 'Drake & Skull', logo: logoDrake },
];

const productList = [
  { name: 'Transformers', Icon: FiZap },
  { name: 'All Types of Electric Poles', Icon: FiTrendingUp },
  { name: 'Concrete Poles', Icon: FiBox },
  { name: 'ACSR Conductors', Icon: FiActivity },
  { name: 'Insulated Armoured Cables', Icon: FiLink },
  { name: 'Cable Boxes', Icon: FiBox },
  { name: 'Pin Insulators', Icon: FiShield },
  { name: 'Disc Insulators', Icon: FiShield },
  { name: 'Drop Out Fuses', Icon: FiAlertTriangle },
  { name: 'Air Break Switches', Icon: FiToggleLeft },
  { name: 'Isolators', Icon: FiToggleRight },
  { name: 'Lightning Arresters', Icon: FiZap },
  { name: 'Control Panels', Icon: FiSettings },
];

// Detailed "What we do, end to end" services — moved over from About page
const services = [
  {
    icon: FiTool,
    title: 'Transformer Manufacturing',
    tag: 'Core Manufacturing',
    desc: 'We manufacture Distribution Transformers (DTR) entirely in-house, from the raw core and winding stages to final testing — giving us complete control over quality at every step.',
    points: [
      'Capacity range from 25 kVA up to 20000 kVA',
      'Oil-cooled design built to relevant BIS standards',
      'Every unit tested for insulation, efficiency & load before dispatch',
    ],
    img: transformerImg,
  },
  {
    icon: FiZap,
    title: 'All Types of Electric Poles',
    tag: 'Core Manufacturing',
    desc: 'Our in-house fabrication unit produces the full range of electric poles used across HT/LT power distribution lines — built to exact client and utility specifications.',
    points: [
      'PSC Pole',
      'Rail Pole',
      'Tubular Pole',
      'Octagonal Pole',
      'RSJ Pole',
    ],
    img: pSteelPole,
  },
  {
    icon: FiShield,
    title: 'Control & Distribution Panels',
    tag: 'Core Manufacturing',
    desc: 'We design and manufacture control panels and distribution boards used across substations, industrial units and utility installations.',
    points: [
      'Built with quality-checked electrical components',
      'Tested for safety, load handling & performance',
      'Custom configurations available as per project need',
    ],
    img: pControlPanel,
  },

  {
    icon: FiTruck,
    title: 'Trading & Supply',
    tag: 'Trading Basis',
    desc: 'Beyond manufacturing, we also source and supply a wider range of electrical goods & components across the full 33 kV range on a trading basis — so clients get everything under one roof.',
    tradingItems: [
      { name: 'ACSR Conductors', img: pACSR },
      { name: 'Lightning Arresters', img: pLA },
      { name: 'Cables', img: pCable },
      { name: 'Insulators', img: pInsulator },
    ],
  },
];

// Quality Testing groups — copied from the Manufacturing page
const testingGroups = [
  {
    icon: FiZap,
    title: 'Transformer Testing',
    img: testTransformerImg,
    points: [
      'Ratio Test (TTR)',
      'Winding Resistance Test',
      'No Load & Load Loss Test',
      'Dielectric Withstand Test',
      'Oil Breakdown Voltage Test',
      'Temperature Rise Test',
    ],
  },
  {
    icon: FiSettings,
    title: 'Control Panel Testing',
    img: testPanelImg,
    points: [
      'Insulation Resistance Test',
      'Dielectric Withstand Test',
      'Functional Operation Test',
      'Protection Relay Test',
      'Wiring & Continuity Check',
      'Busbar & Component Check',
    ],
  },
  {
    icon: FiTool,
    title: 'Pole Testing',
    img: testPoleImg,
    points: [
      'Dimensional Inspection',
      'Galvanization Thickness Test',
      'Weld Quality Inspection',
      'Load / Deflection Test',
      'Verticality & Strength Test',
      'Surface Finish Inspection',
    ],
  },
];

// Custom line-art icons matching the reference style
const IconCalendar = ({ color }) => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
    <rect x="3" y="5" width="18" height="16" rx="2" stroke={color} strokeWidth="1.6" />
    <path d="M3 9.5H21" stroke={color} strokeWidth="1.6" />
    <path d="M7 3V6.5" stroke={color} strokeWidth="1.6" strokeLinecap="round" />
    <path d="M17 3V6.5" stroke={color} strokeWidth="1.6" strokeLinecap="round" />
    <path d="M7.5 13H9.5M11.5 13H13.5M15.5 13H17M7.5 16.5H9.5M11.5 16.5H13.5M15.5 16.5H17"
      stroke={color} strokeWidth="1.4" strokeLinecap="round" />
  </svg>
);

const IconLightning = ({ color }) => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
    <path d="M13 2 L4 14h6l-1 8 9-12h-6l1-8z" stroke={color} strokeWidth="1.6" strokeLinejoin="round" />
  </svg>
);

const IconWrench = ({ color }) => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
    <path
      d="M14.7 6.3a4 4 0 0 0-5.4 5.4L3 18l3 3 6.3-6.3a4 4 0 0 0 5.4-5.4l-2.83 2.83-2.12-2.12L14.7 6.3z"
      stroke={color}
      strokeWidth="1.6"
      strokeLinejoin="round"
      strokeLinecap="round"
    />
  </svg>
);

const IconUsers = ({ color }) => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
    <circle cx="9" cy="8" r="3" stroke={color} strokeWidth="1.6" />
    <path d="M3.5 20c0-3 2.5-5.5 5.5-5.5S14.5 17 14.5 20" stroke={color} strokeWidth="1.6" strokeLinecap="round" />
    <circle cx="17" cy="9" r="2.4" stroke={color} strokeWidth="1.6" />
    <path d="M15.8 14.6c2.6.2 4.7 2.3 4.7 5" stroke={color} strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

// Rotating gradient ring wrapper — exact style from reference
const GradientRingIcon = ({ Icon, colorFrom, colorTo, id }) => (
  <div className="relative flex h-20 w-20 items-center justify-center">
    <svg viewBox="0 0 100 100" className="absolute inset-0 h-full w-full">
      <defs>
        <linearGradient id={`grad-${id}`} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={colorFrom} />
          <stop offset="100%" stopColor={colorTo} />
        </linearGradient>
      </defs>
      <path d="M 25 20 A 35 35 0 0 1 78 40" fill="none" stroke={`url(#grad-${id})`} strokeWidth="3.5" strokeLinecap="round" />
      <path d="M 70 32 L 78 40 L 68 44" fill="none" stroke={colorFrom} strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M 75 80 A 35 35 0 0 1 22 60" fill="none" stroke={`url(#grad-${id})`} strokeWidth="3.5" strokeLinecap="round" />
      <path d="M 30 68 L 22 60 L 32 56" fill="none" stroke={colorTo} strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
    <Icon color={colorTo} />
  </div>
);

const whyUs = [
  {
    icon: FiShield,
    title: 'Govt. Approved Manufacturer',
    desc: 'Registered manufacturer & trader for electrical power distribution equipment.',
  },
  {
    icon: FiCalendar,
    title: '17+ Years Experience',
    desc: 'Hands-on expertise across the power distribution sector since inception.',
  },
  {
    icon: FiGlobe,
    title: 'Multi-State Delivery',
    desc: 'Projects executed and delivered across multiple states in India.',
  },
  {
    icon: FiTool,
    title: 'In-House Manufacturing',
    desc: 'DTRs, poles & panels made on our own floor — quality stays in our hands.',
  },
  {
    icon: FiUsers,
    title: 'Trusted by Major Clients',
    desc: 'Worked with L&T, Shapoorji Pallonji, Indian Oil and other leading names.',
  },
  {
    icon: FiCheckCircle,
    title: 'Zero Defect Policy',
    desc: 'Every product tested and verified against BIS & IEC standards before dispatch.',
  },
];

// Quality Policy checklist — same content as reference
const qualityPolicy = [
  {
    title: 'ISO 9001:2015 Certified',
    desc: 'Quality management system certification',
  },
  {
    title: 'IEC / BIS Aligned',
    desc: 'Design & type-testing per Indian and international standards',
  },
  {
    title: 'NABL Tested',
    desc: 'Calibration lab verified — accuracy on every component',
  },
  {
    title: 'Government Approved',
    desc: 'Registered contractor for public distribution projects',
  },
];

// Company Information cards — content pulled from the Prithviraj catalogue
const companyInfo = [
  {
    icon: FiGlobe,
    title: 'About Prithviraj',
    desc: 'A government-approved manufacturer & trader of electrical power distribution equipment, with our registered workshop at Barauni, Begusarai, Bihar, and a corporate office in Gurugram, Haryana. Since 2018, we\'ve built our reputation on responsiveness, delivery commitments, and unparalleled quality.',
    img: null, // TODO: client image pending — add to src/assest/company/about.jpg and set here
  },
  {
    icon: FiTarget,
    title: 'Goal & Vision',
    desc: 'To achieve consistency in delivering high-quality, value-added manufacturing & trading services through absolute professionalism and timely execution — and to be recognized as a key player in the power distribution sector.',
    img: imgVision,
  },
  {
    icon: FiSettings,
    title: 'Our Services',
    desc: 'In-house manufacturing of DTRs from 25 kVA to 20000 kVA, steel structure fabrication, and trading of electrical goods across the full 33 kV voltage range.',
    img: imgServices,
  },
  {
    icon: FiHome,
    title: 'Our Facilities',
    desc: 'A dedicated manufacturing workshop at Barauni, Begusarai, Bihar for transformers and steel fabrication, backed by a corporate office at Aspaze I Tech Park, Sohna Road, Gurugram.',
    img: imgFacilities,
  },
];

// ---------------------------------------------------------------------------
// "OUR RANGE" spotlight cards — each carries the EXACT category title
// (as used in src/data/categories.js) so the "View Details" button can jump
// straight to that category's section on the Products page, instead of just
// opening the Products page at the top.
// ---------------------------------------------------------------------------
const rangeItems = [
  { name: 'Transformers', desc: 'In-house DTR manufacturing, 25 kVA – 20000 kVA.', img: transformerImg, category: 'Transformers' },
  { name: 'All Types of Electric Poles', desc: 'PSC, Rail, Tubular, Octagonal & RSJ poles for HT/LT lines.', img: pSteelPole, category: 'Tower & Pole Support' },
  { name: 'Control & Distribution Panels', desc: 'Quality-checked panels for power distribution.', img: pControlPanel, category: 'Control Panel' },
  { name: 'All Types of Electrical GI Fabrication', desc: 'Custom GI fabrication for transmission & distribution structures.', img: pGIFabrication, category: 'Electrical GI Fabrication' },
  { name: 'ACSR Conductors', desc: 'Reliable conductors across the 33 kV range.', img: pACSR, category: 'Electrical Conductors' },
  { name: 'Lightning Arresters', desc: '11kV polymeric type arresters.', img: pLA, category: 'Lightning Arrestor' },
  { name: 'Cables', desc: 'MV XLPE insulated armoured cables.', img: pCable, category: 'Insulated Armoured Cables' },
  { name: 'Insulators', desc: '33kV polymer pin insulators, 10kN strength.', img: pInsulator, category: 'Pin Insulators' },
];

export default function Home() {
  return (
    <div className="overflow-x-hidden ">
      {/* ---------------- HERO SLIDER ---------------- */}
      <HeroSlider />

      {/* ---------------- PRODUCT NAME MARQUEE (below hero) ---------------- */}
      <section className="w-full overflow-hidden  bg-navy py-4">
        <div className="overflow-hidden">
          <div className="marquee-track flex items-center gap-12 pl-10">
            {[...productList, ...productList].map((p, i) => {
              const Icon = p.Icon;
              return (
                <span key={p.name + i} className="flex items-center gap-3 whitespace-nowrap">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white text-brand-orange shadow-sm">
                    <Icon size={16} strokeWidth={2.5} />
                  </span>
                  <span className="text-lg font-extrabold uppercase tracking-wide text-white transition-all duration-200 hover:scale-110 sm:text-2xl">
                    {p.name}
                  </span>
                </span>
              );
            })}
          </div>
        </div>
      </section>

      {/* ---------------- STATS ---------------- */}
   <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
  <div className="rounded-3xl bg-navy px-4 py-10 sm:px-10 sm:py-16">
    <Reveal className="mb-10 text-center sm:mb-12">
      {/* Main Heading */}
      <h2 className="text-3xl font-extrabold uppercase leading-tight sm:text-5xl lg:text-6xl">
        <span className="hero-shimmer block text-brand-orange">
          BY THE NUMBERS
        </span>
      </h2>

      {/* Secondary Heading */}
      <h3 className="mt-3 text-xl font-bold text-white sm:mt-4 sm:text-3xl lg:text-4xl">
        Our Key Numbers
      </h3>
    </Reveal>

    <div className="grid grid-cols-2 gap-x-3 gap-y-10 sm:grid-cols-4 sm:gap-x-6 sm:gap-y-12">
      {[
        { Icon: IconCalendar, value: 17, suffix: '+', label: 'Years in the sector' },
        { Icon: IconLightning, value: 33, suffix: ' kV', label: 'Voltage range served' },
        { Icon: IconWrench, value: 20000, suffix: ' kVA', label: 'Transformer capacity' },
        { Icon: IconUsers, value: 7, suffix: '+', label: 'Major clients served' },
      ].map((s, i) => (
        <Reveal key={s.label} delay={i * 100}>
          <div className="flex flex-col items-center px-1 text-center transition-transform duration-300 hover:-translate-y-1">
            <GradientRingIcon Icon={s.Icon} colorFrom="#34d399" colorTo="#38bdf8" id={`stat-${i}`} />

            {/* Fixed-height wrapper so the line below always sits at the same spot,
                whether the number wraps to 1 line ("7+") or 2 lines ("20000 kVA") */}
            <div className="mt-4 flex min-h-[3.5rem] items-end justify-center sm:min-h-[4.5rem]">
              <p className="text-2xl font-extrabold leading-tight text-white sm:text-4xl lg:text-5xl">
                <Counter value={s.value} suffix={s.suffix} />
              </p>
            </div>

            <span className="mt-3 block h-1 w-12 rounded-full bg-gradient-to-r from-emerald-400 to-sky-400" />
            <p className="mx-auto mt-3 max-w-[8rem] text-[10px] font-semibold uppercase leading-snug tracking-wide text-white/60 sm:max-w-none sm:text-sm">
              {s.label}
            </p>
          </div>
        </Reveal>
      ))}
    </div>
  </div>
</section>


      {/* ---------------- PRODUCT SPOTLIGHT (one product per section, animated) ---------------- */}
      <section className="relative py-16 sm:py-20  overflow-hidden">
        <div className="pointer-events-none absolute -top-24 left-1/2 h-72 w-72 -translate-x-1/2 rounded-full bg-brand-orange/10 blur-3xl" />

        <style>{`
          .pcard {
            position: relative;
            width: 256px;
            border-radius: 20px;
            padding: 3px;
            background: linear-gradient(163deg, #abd373 0%, #ff9f0d 100%);
            transition: box-shadow .35s ease, transform .35s ease;
            cursor: pointer;
          }
          .pcard:hover {
            box-shadow: 0 0 25px 2px rgba(171, 211, 115, 0.55),
                        0 0 45px 6px rgba(255, 159, 13, 0.25);
            transform: translateY(-6px);
          }
          .pcard-inner {
            width: 100%;
            height: 100%;
            border-radius: 18px;
            background-color: #101a2c;
            padding: 24px 20px;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 8px;
            transition: transform .25s ease, background-color .25s ease;
          }
          .pcard:hover .pcard-inner {
            transform: scale(0.96);
          }
          .pcard-inner img {
            transition: transform .35s ease;
          }
          .pcard:hover .pcard-inner .pcard-img {
            transform: translateY(-6px);
          }
          /* description grows to fill leftover space so the button always lands at the same spot */
          .pcard-desc {
            flex: 1 1 auto;
            display: flex;
            align-items: flex-start;
            justify-content: center;
          }
          /* button pinned to bottom of the card, regardless of description length */
          .pcard-btn {
            margin-top: auto;
          }
        `}</style>

        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <Reveal className="mx-auto max-w-3xl text-center">
            {/* Main Heading */}
            <h2 className="text-4xl font-extrabold uppercase leading-none sm:text-5xl lg:text-6xl">
              <span className="hero-shimmer block text-brand-orange">
                OUR RANGE
              </span>
            </h2>

            {/* Secondary Heading */}
            <h3 className="mt-4 text-2xl font-bold text-navy sm:text-3xl lg:text-4xl">
              Explore Our Product Range
            </h3>

            {/* Description */}
            <p className="mx-auto mt-5 max-w-2xl text-base leading-7 text-slate-600  sm:text-lg">
              From in-house manufactured transformers to a full range of traded
              electrical components.
            </p>
          </Reveal>

          <div className="mt-12 flex flex-wrap items-stretch justify-center gap-6">
            {rangeItems.map((p) => (
              <div key={p.name} className="pcard">
                <div className="pcard-inner">
                  <div className="pcard-img w-28 aspect-square rounded-full p-2 bg-white overflow-hidden shadow-md mx-auto">
                    <img src={p.img} alt={p.name} className="h-full w-full object-contain" />
                  </div>

                  <p className="font-semibold text-white tracking-wide text-lg text-center">
                    {p.name}
                  </p>

                  {/* grows to fill leftover space so button aligns across cards */}
                  <p className="pcard-desc font-medium text-white/60 text-xs text-center">
                    {p.desc}
                  </p>

                  {/* Jumps straight to this product's category section on the
                      Products page (e.g. /products#transformers) instead of
                      just opening /products at the top. */}
                  <Link
                    to={`/products#${slugify(p.category)}`}
                    className="pcard-btn inline-flex items-center gap-2 py-2 px-5 text-sm font-semibold rounded-full
                      bg-brand-orange text-white shadow-[0_0_20px_rgba(255,159,13,0.4)]"
                  >
                    View Details
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ---------------- PRODUCT CATEGORY REEL (big centered title + sliding images) ---------------- */}
      <CategoryReel />

      {/* ---------------- SERVICES: "What we do, end to end" (detailed rows: text + image) ---------------- */}
      <section className="py-16 sm:py-20 overflow-hidden">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <Reveal className="mx-auto max-w-3xl text-center">
            {/* Main Heading */}
            <h2 className="break-words text-4xl font-extrabold uppercase leading-none sm:text-5xl lg:text-6xl">
              <span className="hero-shimmer block text-brand-orange">
                AT A GLANCE
              </span>
            </h2>

            {/* Secondary Heading */}
            <h3 className="mt-4 break-words text-xl font-bold leading-tight text-navy sm:text-2xl lg:text-3xl">
              What We Do, End to End
            </h3>

            {/* Description */}
            <p className="mx-auto mt-5 max-w-2xl text-base leading-7 text-slate-600 sm:text-lg">
              Manufacturing kept in-house, quality kept in our hands — supported by
              trading & supply for everything else our clients need.
            </p>
          </Reveal>

          <div className="mt-14 grid gap-6 sm:grid-cols-2">
            {services.map((s, i) => {
              const Icon = s.icon;
              const isTrading = s.tag === 'Trading Basis';
              return (
                <Reveal key={s.title} delay={i * 80}>
                  {/* ---- outer wrapper: subtle static gradient border (no spin) ---- */}
                  <div className="group relative h-full overflow-hidden rounded-3xl p-[1.5px] bg-gradient-to-br from-brand-orange/25 via-white/5 to-transparent">
                    {/* ---- actual card: flat solid dark navy background ---- */}
                    <div
                      className="relative z-10 flex h-full flex-col rounded-3xl bg-[#0B0F1F] p-6 shadow-[inset_0_-16px_24px_0_rgba(255,255,255,0.03)] transition-transform duration-300 ease-out sm:p-7"
                    >
                      {/* Icon + Tag */}
                      <div className="flex items-center gap-3">
                        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white/10 text-brand-orange">
                          <Icon size={20} />
                        </span>
                        <span className="inline-flex items-center rounded-full bg-white/10 px-3 py-1 text-[11px] font-bold uppercase tracking-wide text-brand-orange">
                          {s.tag}
                        </span>
                      </div>

                      {/* Title */}
                      <h2 className="mt-4 text-xl font-extrabold text-white sm:text-2xl">
                        {s.title}
                      </h2>

                      {/* Description */}
                      <p className="mt-2 text-sm leading-relaxed text-white/70">
                        {s.desc}
                      </p>

                      <span className="mt-4 block h-[1px] w-full bg-white/10" />

                      {/* Content row: points + image tile(s) */}
                      <div className="mt-4 flex flex-1 items-start gap-5">
                        {s.points && (
                          <ul className="flex-1 space-y-2.5">
                            {s.points.map((pt) => (
                              <li key={pt} className="flex items-start gap-2">
                                <FiCheckCircle className="mt-0.5 shrink-0 text-brand-orange" size={15} />
                                <span className="text-xs leading-relaxed text-white/80 sm:text-sm">{pt}</span>
                              </li>
                            ))}
                          </ul>
                        )}

                        {isTrading ? (
                          <div className="grid shrink-0 grid-cols-2 gap-2.5">
                            {s.tradingItems.map((item) => (
                              <div
                                key={item.name}
                                className="flex h-16 w-16 items-center justify-center overflow-hidden rounded-full bg-white p-2.5 shadow-md ring-1 ring-white/20 transition-transform duration-300 ease-out group-hover:scale-105 sm:h-20 sm:w-20"
                                title={item.name}
                              >
                                <img
                                  src={item.img}
                                  alt={item.name}
                                  className="h-full w-full object-contain"
                                  loading="lazy"
                                />
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div className="flex h-28 w-28 shrink-0 items-center justify-center overflow-hidden rounded-full bg-white p-4 shadow-md ring-1 ring-white/20 transition-transform duration-300 ease-out group-hover:scale-105 sm:h-32 sm:w-32">
                            <img
                              src={s.img}
                              alt={s.title}
                              className="h-full w-full object-contain"
                              loading="lazy"
                            />
                          </div>
                        )}
                      </div>

                      {/* Button — same gradient pill style as contact form submit */}
                      <Link
                        to="/products"
                        className="group/btn mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-gradient-to-t from-brand-orangedark to-brand-orange px-6 py-3 text-sm font-bold uppercase tracking-wide text-white shadow-[inset_0_-2px_25px_-4px_rgba(255,255,255,0.4)] transition hover:-translate-y-0.5"
                      >
                        View Details
                        <FiArrowRight className="transition group-hover/btn:translate-x-1" size={15} />
                      </Link>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>

      {/* ---------------- QUALITY TESTING (copied from Manufacturing page) ---------------- */}
      <section className="relative py-16 sm:py-20 overflow-hidden">
        <div className="pointer-events-none absolute -top-24 left-1/2 h-72 w-72 -translate-x-1/2 rounded-full bg-brand-orange/10 blur-3xl" />

        <style>{`
          .tcard {
            position: relative;
            border-radius: 24px;
            padding: 2px;
            background: linear-gradient(163deg, #abd373 0%, #ff9f0d 100%);
            transition: box-shadow .35s ease, transform .35s ease;
          }
          .tcard:hover {
            box-shadow: 0 0 14px 1px rgba(171, 211, 115, 0.3),
                        0 0 24px 3px rgba(255, 159, 13, 0.15);
            transform: translateY(-3px);
          }
          .tcard-inner {
            width: 100%;
            height: 100%;
            border-radius: 22px;
            background-color: #101a2c;
            transition: transform .25s ease;
            overflow: hidden;
          }
          .tcard:hover .tcard-inner {
            transform: scale(0.995);
          }
        `}</style>

        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <Reveal className="mx-auto max-w-3xl text-center">
            <h2 className="text-4xl font-extrabold uppercase leading-none sm:text-5xl lg:text-6xl">
              <span className="hero-shimmer block text-brand-orange">
                QUALITY TESTING
              </span>
            </h2>

            <h3 className="mt-4 text-2xl font-bold text-navy sm:text-3xl lg:text-4xl">
              Every Product, Tested Before It Ships
            </h3>

            <p className="mx-auto mt-5 max-w-2xl text-base leading-7 text-slate-600 sm:text-lg ">
              Dedicated test setups for transformers, panels and poles — so nothing
              leaves our floor without being verified against specifications.
            </p>
          </Reveal>

          <div className="mt-12 space-y-10">
            {testingGroups.map((group, i) => {
              const Icon = group.icon;
              const imgFirst = i % 2 === 1;
              return (
                <div key={group.title} className="tcard">
                  <div className="tcard-inner grid items-stretch gap-8 p-6 sm:p-8 lg:grid-cols-2 lg:gap-12">
                    <Reveal direction="right" className={imgFirst ? 'order-2 lg:order-1' : ''}>
                      {imgFirst ? (
                        <div className="h-56 w-full overflow-hidden rounded-2xl sm:h-64 lg:h-full">
                          <img src={group.img} alt={group.title} className="h-full w-full object-cover" loading="lazy" />
                        </div>
                      ) : (
                        <div className="flex h-full flex-col justify-center">
                          <div className="flex items-center gap-3">
                            <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-white/10 text-brand-orange">
                              <Icon size={20} />
                            </span>
                            <h3 className="text-lg font-extrabold text-white sm:text-xl">{group.title}</h3>
                          </div>
                          <ul className="mt-5 grid grid-cols-1 gap-2.5 sm:grid-cols-2">
                            {group.points.map((p) => (
                              <li key={p} className="flex items-start gap-2 text-sm text-white/90">
                                <FiCheckCircle className="mt-0.5 shrink-0 text-brand-orange" size={16} />
                                <span>{p}</span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </Reveal>
                    <Reveal direction="left" delay={120} className={imgFirst ? 'order-1 lg:order-2' : ''}>
                      {imgFirst ? (
                        <div className="flex h-full flex-col justify-center">
                          <div className="flex items-center gap-3">
                            <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-white/10 text-brand-orange">
                              <Icon size={20} />
                            </span>
                            <h3 className="text-lg font-extrabold text-white sm:text-xl">{group.title}</h3>
                          </div>
                          <ul className="mt-5 grid grid-cols-1 gap-2.5 sm:grid-cols-2">
                            {group.points.map((p) => (
                              <li key={p} className="flex items-start gap-2 text-sm text-white/90">
                                <FiCheckCircle className="mt-0.5 shrink-0 text-brand-orange" size={16} />
                                <span>{p}</span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      ) : (
                        <div className="h-56 w-full overflow-hidden rounded-2xl sm:h-64 lg:h-full">
                          <img
                            src={group.img}
                            alt={group.title}
                            className="h-full w-full scale-110 object-cover object-right"
                            loading="lazy"
                          />
                        </div>
                      )}
                    </Reveal>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* ---------------- COMPANY INFORMATION ---------------- */}
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
        <Reveal className="mx-auto max-w-3xl text-center">
          {/* Main Heading */}
          <h2 className="text-4xl font-extrabold uppercase leading-none sm:text-5xl lg:text-6xl">
            <span className="hero-shimmer block text-brand-orange">
              COMPANY INFORMATION
            </span>
          </h2>

          {/* Secondary Heading */}
          <h3 className="mt-4 text-2xl font-bold text-navy sm:text-3xl lg:text-4xl">
            Who We Are & What We Stand For
          </h3>
        </Reveal>

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {companyInfo.map((c, i) => {
            const Icon = c.icon;
            return (
              <Reveal key={c.title} delay={i * 100}>
                <div className="group relative h-80 overflow-hidden rounded-2xl shadow-md transition duration-300 hover:-translate-y-1.5 hover:shadow-xl">
                  {/* fallback flat navy background until a client image is provided */}
                  {!c.img && <div className="absolute inset-0 bg-navy" />}

                  {/* subtle zoom + brighten on hover */}
                  {c.img && (
                    <div
                      className="absolute inset-0 scale-100 bg-cover bg-center brightness-110 transition-transform duration-500 group-hover:scale-110"
                      style={{ backgroundImage: `url(${c.img})` }}
                    />
                  )}

                  {/* dark gradient overlay so the text stays readable */}
                  <div className="absolute inset-0 bg-gradient-to-t from-navy/90 via-navy/50 to-navy/10" />

                  <div className="relative z-10 flex h-full flex-col justify-between p-7">
                    <span className="flex h-14 w-14 items-center justify-center rounded-full bg-white/10 text-white backdrop-blur-sm transition duration-300 group-hover:bg-brand-orange">
                      <Icon size={24} />
                    </span>
                    <div>
                      <h3 className="text-lg font-bold text-white">{c.title}</h3>
                      <p className="mt-3 text-sm leading-relaxed text-white">{c.desc}</p>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>

      {/* ---------------- WHY CHOOSE US ---------------- */}
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid items-center gap-12 lg:grid-cols-2">
          {/* IMAGE SIDE */}
          <Reveal direction="right">
            <div className="relative overflow-hidden rounded-3xl shadow-xl">
              <img
                src={imgFacilities}
                alt="Prithviraj Corporation workshop"
                className="h-[420px] w-full object-cover sm:h-[480px]"
              />
            </div>
          </Reveal>

          {/* TEXT + FEATURE GRID SIDE */}
          <Reveal direction="left" delay={150}>
            {/* Main Heading — same shimmer style as other sections */}
            <h2 className="text-4xl font-extrabold uppercase leading-none sm:text-5xl lg:text-6xl">
              <span className="hero-shimmer block text-brand-orange">
                WHY PRITHVIRAJ
              </span>
            </h2>

            {/* Secondary Heading */}
            <h3 className="mt-4 text-2xl font-bold text-navy sm:text-3xl lg:text-4xl">
              Built on Quality, Backed by Experience
            </h3>

            <p className="mt-4 text-slate-600">
              From tendering to execution, we track every stage of a project —
              planning, procurement and implementation — so our clients get
              consistent, reliable delivery.
            </p>

            <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2">
              {whyUs.map((item) => {
                const Icon = item.icon;
                return (
                  <div
                    key={item.title}
                    className="group flex items-start gap-4 rounded-xl border border-brand-orange/20 bg-white p-4 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-brand-orange hover:shadow-lg"
                  >
                    <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg border-2 border-brand-orange/30 bg-brand-orange/5 text-brand-orange transition-all duration-300 group-hover:border-brand-orange group-hover:bg-brand-orange group-hover:text-white">
                      <Icon size={22} />
                    </span>
                    <div>
                      <h4 className="text-sm font-bold text-navy">{item.title}</h4>
                      <p className="mt-1 text-sm text-slate-500">{item.desc}</p>
                    </div>
                  </div>
                );
              })}
            </div>

            <Link
              to="/about"
              className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-brand-orange hover:text-brand-orangedark"
            >
              More about us <FiArrowRight />
            </Link>
          </Reveal>
        </div>
      </section>

      {/* ---------------- QUALITY POLICY ---------------- */}
      <section className=" py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid gap-12 lg:grid-cols-2">
            <Reveal direction="right">
              <span className="inline-flex items-center gap-2 rounded-full bg-brand-orange/10 px-4 py-1.5 font-mono text-sm font-bold uppercase tracking-[0.2em] text-brand-orange">
                [06] Quality Policy
              </span>
              <h2 className="mt-4 text-3xl font-extrabold leading-[1.1] text-[#14110F] sm:text-4xl lg:text-5xl">
                Zero defect. Not a<br />
                slogan — a workshop<br />
                discipline.
              </h2>
              <p className="mt-6 max-w-md text-slate-600">
                Every product coming out of our facility is inspected against Bureau of Indian
                Standards (BIS) specifications and IEC references. We follow a philosophy of
                continuous improvement inspired by the Zero Defect / Zero Effect approach.
              </p>
            </Reveal>

            <Reveal direction="left" delay={150}>
              <div className="divide-y divide-[#e3ded2] border-t border-[#e3ded2]">
                {qualityPolicy.map((item) => (
                  <div
                    key={item.title}
                    className="group flex items-start justify-between gap-6 rounded-xl border border-[#e3ded2] bg-white p-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
                  >
                    <div>
                      <h3 className="text-lg font-extrabold text-[#14110F] transition-colors duration-300 group-hover:text-brand-orange sm:text-xl">
                        {item.title}
                      </h3>
                      <p className="mt-1 text-sm text-slate-500 sm:text-base">{item.desc}</p>
                    </div>
                    <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border-2 border-brand-orange text-brand-orange">
                      <FiCheck size={16} strokeWidth={3} />
                    </div>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <div className="mx-auto -mt-4 max-w-7xl px-4 pb-4 text-center sm:px-6 lg:px-8">
        <Link
          to="/products"
          className="inline-flex items-center gap-2 text-sm font-semibold text-navy hover:text-brand-orange"
        >
          View full catalogue <FiArrowRight />
        </Link>
      </div>

      {/* ---------------- TRUSTED BY MARQUEE ---------------- */}
      <section className="border-y border-slate-100  py-6">
        <style>{`
          .logo-marquee-wrap {
            overflow: hidden;
          }
          .logo-marquee-track {
            display: flex;
            width: max-content;
            animation: logo-marquee-scroll 30s linear infinite;
          }
          /* The array is duplicated 3 times, so the track moves exactly -33.3333%.
             At that point the second copy sits exactly where the first copy started,
             so the loop restarts with no visible jump, pause, or gap.
             If any other CSS class uses this same name elsewhere it could override
             this rule — the unique class name (logo-marquee-track) avoids that clash. */
          @keyframes logo-marquee-scroll {
            from { transform: translateX(0); }
            to   { transform: translateX(-33.3333%); }
          }
          .logo-marquee-wrap:hover .logo-marquee-track {
            animation-play-state: paused;
          }
        `}</style>

        <p className="mb-4 text-center text-xs font-bold uppercase tracking-[0.3em] text-slate-600">
          TRUSTED BY ORGANIZATIONS WE HAVE WORKED WITH
        </p>
        <div className="logo-marquee-wrap">
          <div className="logo-marquee-track items-center gap-14 pl-10">
            {[...clientLogos, ...clientLogos, ...clientLogos].map((c, i) => (
              <span
                key={c.name + i}
                className="flex h-14 shrink-0 items-center justify-center whitespace-nowrap transition-transform duration-300 hover:scale-110"
              >
                <img
                  src={c.logo}
                  alt={c.name}
                  className="h-12 w-auto max-w-[160px] object-contain mix-blend-multiply sm:h-14"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.onerror = null;
                    target.style.display = 'none';
                    const fallback = document.createElement('span');
                    fallback.textContent = c.name;
                    fallback.className =
                      'flex h-12 items-center justify-center px-3 text-sm font-bold text-slate-500 sm:h-14';
                    target.parentElement.appendChild(fallback);
                  }}
                />
              </span>
            ))}
          </div>
        </div>
      </section>

      {/* ---------------- CTA ---------------- */}
      <section className="px-4 py-16 sm:px-6 lg:px-8">
        <Reveal className="mx-auto max-w-5xl overflow-hidden rounded-3xl bg-navy px-8 py-12 text-center text-white sm:px-16">
          <h2 className="text-2xl font-extrabold sm:text-3xl">
            Need electrical manufacturing or trading services?
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-white/70">
            Tell us about your project and our team will get back to you with a plan and a quote.
          </p>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 rounded-full bg-brand-orange px-6 py-3 text-sm font-semibold text-white transition hover:-translate-y-0.5 hover:bg-brand-orangedark"
            >
              <FiPhoneCall /> Talk to Us
            </Link>
            <a
              href="tel:+919958260035"
              className="inline-flex items-center gap-2 rounded-full border border-white/30 px-6 py-3 text-sm font-semibold text-white transition hover:-translate-y-0.5 hover:border-white"
            >
              +91 9958260035
            </a>
          </div>
        </Reveal>
      </section>
    </div>
  );
}